import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12 11.75A3.48 3.48 0 0 1 8.965 10a3.48 3.48 0 0 1 0-3.5A3.54 3.54 0 0 1 12 4.75c1.23 0 2.379.684 3.008 1.75a3.48 3.48 0 0 1 0 3.5A3.47 3.47 0 0 1 12 11.75m-1.258 1.313h2.488a4.89 4.89 0 0 1 4.895 4.894c0 .438-.383.793-.82.793H6.668a.794.794 0 0 1-.793-.793c0-2.707 2.16-4.895 4.867-4.895"
    }, null, -1)
  ]))]))
}
export default { render: render }